import React from "react";
import { SvgIcon } from "@mui/material";
import PropTypes from "prop-types";

const HomeworkIcon = ({ color, fontSize }) => {
  return (
    <SvgIcon color={color} fontSize={fontSize}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6525 14.0213C15.2625 14.4113 14.6325 14.4113 14.2425 14.0213L9.2925 9.07126C8.9025 8.68126 8.9025 8.05126 9.2925 7.66126L15.6625 1.29126C16.0525 0.901262 16.6825 0.901262 17.0625 1.30126L22.0125 6.25126C22.4025 6.64126 22.4025 7.27126 22.0125 7.66126L15.6525 14.0213ZM19.9025 6.95126L16.3625 3.41126L11.4125 8.36126L14.9525 11.9013L19.9025 6.95126ZM2 8V20.2804L2.83753 17.9007L2 20.2857C2 21.2286 2.9 22 4 22H18C19.1 22 20.5 21.5 21 20.2857L24 11.7143C24 10.7714 23.1 10 22 10L17 15C15 17 13 15 13 15L8 10H7C5.9 10 5.5 10.5 5.01 11.7143L4 14.5904V8H7L9 6H4C2 6 2 8 2 8Z"
      />
    </SvgIcon>
  );
};

export default HomeworkIcon;

HomeworkIcon.propTypes = {
  color: PropTypes.string
};

HomeworkIcon.defaultProps = {
  color: "inherit"
};
